import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { PlanAncestors } from "./PlanAncestors";
import { useGetPlanAncestorsQuery } from "src/store/api/generatedApi";
import { useTenant } from "hooks/settings";

interface Props {
  planId: number;
}

export const PlanAncestorsTooltip = ({ planId }: Props) => {
  const theme = useTheme();
  const tenantName = useTenant();
  const { data, isLoading } = useGetPlanAncestorsQuery({
    tenantName,
    planId,
  });
  return (
    <Box
      sx={{
        maxHeight: "60vh",
        overflowY: "auto",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        width: 400,
      }}
    >
      <PlanAncestors isLoading={isLoading} ancestors={data?.ancestors ?? []} />
    </Box>
  );
};
